// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4129 ? "7bf36345" : chunkId) + "." + {"1919":"da2166749b5d5e6e","2741":"5a19e689cbd03c41","3035":"f3e2da3f257a8ba7","4129":"94adc6240e4054d8","6047":"c57f770373d9ad7e","6885":"b35a1c6c6f3e4ff9","7733":"a80ee904c028ec60","8428":"1e4df18f89579330"}[chunkId] + ".js";
};